export type { ValidatorIndexType } from "./ValidatorIndexType.js";

import { equals } from "./equals.js";
import { from } from "./from.js";
import { toNumber } from "./toNumber.js";

export { from, toNumber, equals };

export const ValidatorIndex = {
	from,
	toNumber,
	equals,
};
